import type { ApprovalAttributes } from '@/types/approval';
import {
  SERP_NOT_LOADED_MESSAGE,
  type SerpDocumentRef,
} from '@/utils/approval/serpDocument';

/** SERP AP 재고 이관 요청 — 레거시 appr_edit_forms_serp_ap_inventory_transfer */
export const SERP_AP_STOCK_TRANSFER_TYPE = 170;

export const isSerpApStockTransferType = (apvType: number): boolean =>
  apvType === SERP_AP_STOCK_TRANSFER_TYPE;

export type SerpApStockTransferItem = {
  ssnCd?: unknown;
  prodCd?: unknown;
  colorCd?: unknown;
  sizCd?: unknown;
  reqQty?: unknown;
  signQty?: unknown;
  fromApNm?: unknown;
  toApNm?: unknown;
};

/** EAI 응답 원문(이 양식만 camelCase) — 저장 attributes.data 에 손대지 않고 그대로 보관 */
export type SerpApStockTransferSource = {
  brandCd?: unknown;
  stkTrReqNo?: unknown;
  reqDe?: unknown;
  reqrId?: unknown;
  trRsn?: unknown;
  stkTrReqDtl?: SerpApStockTransferItem[] | null;
  [key: string]: unknown;
};

export type SerpApStockTransferDraftSource = {
  code: number;
  attributes: SerpDocumentRef;
  display: { source?: SerpApStockTransferSource | null };
};

export type SerpApStockTransferState = SerpDocumentRef & {
  source: SerpApStockTransferSource;
};

export const getSerpApStockTransferRows = (
  source: SerpApStockTransferSource,
): SerpApStockTransferItem[] =>
  Array.isArray(source.stkTrReqDtl) ? source.stkTrReqDtl : [];

export const checkSerpApStockTransferBeforeSave = (
  state: SerpApStockTransferState | null | undefined,
): string | null => (state?.source ? null : SERP_NOT_LOADED_MESSAGE);

export const buildSerpApStockTransferAttributes = (
  state: SerpApStockTransferState | null | undefined,
  content: string,
): ApprovalAttributes | null =>
  state?.source
    ? {
        typeCode: state.typeCode,
        sequence: state.sequence,
        content,
        data: state.source,
      }
    : null;
